<template>
    <Breadcrumbs main="Ui Kits" title="Typography" />
    <div class="container-fluid">
        <div class="row">
            <headingsSeaction />
            <coloredHeadings />
            <fontWeight />
            <listingTypography />
            <displayHeadings />
            <textElements />
        </div>
    </div>
</template>
<script lang="ts" setup>
import { ref, defineAsyncComponent } from 'vue'
const headingsSeaction = defineAsyncComponent(() => import("@/components/theme/uikits/typography/headingsSeaction.vue"))
const coloredHeadings = defineAsyncComponent(() => import("@/components/theme/uikits/typography/coloredHeadings.vue"))
const fontWeight = defineAsyncComponent(() => import("@/components/theme/uikits/typography/fontWeight.vue"))
const listingTypography = defineAsyncComponent(() => import("@/components/theme/uikits/typography/listingTypography.vue"))
const displayHeadings = defineAsyncComponent(() => import("@/components/theme/uikits/typography/displayHeadings.vue"))
const textElements = defineAsyncComponent(() => import("@/components/theme/uikits/typography/textElements.vue"))
</script>